import { createApiInstance } from './config'

const api = createApiInstance()

export const answerRecordAPI = {
  submit(data) {
    return api.post('/answer-records/submit', data)
  },

  list(page = 1, pageSize = 20, keyword = null) {
    const params = { page, pageSize }
    if (keyword != null && String(keyword).trim()) {
      params.keyword = String(keyword).trim()
    }
    return api.get('/answer-records/list', { params })
  },

  latest(windowId = null) {
    const params = {}
    if (windowId != null && String(windowId).trim()) {
      params.window_id = String(windowId).trim()
    }
    return api.get('/answer-records/latest', { params })
  }
}

export default answerRecordAPI
